export const setUrlPathFromDomainForV25 = (
  pathForLocal: string,
  pathForDev: string,
  pathForProd: string
): string => {
  if (document.domain === 'localhost') {
    return pathForLocal;
  } else if (document.domain === 'argos-v19.itmsol.fr') {
    return pathForProd;
  } else if (document.domain === 'argos-dev.itmsol.fr') {
    return pathForDev;
  }
  return pathForProd;
};
